import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useToast } from "../../../Hooks/ToasContext";
import { IPricePoliciesEntity } from "../../../Services/api/price-policies/price-policies.interface";
import { ListPricePoliciesUseCase } from "../../../Usecase/PricePolicies/list-price-policies-usecase";
import { DestroyProductUseCase } from "../../../Usecase/Products/destroy-product-usecase";
import { DestroyPricePoliciesUseCase } from "../../../Usecase/PricePolicies/destroy-price-policies-usecase";
import { ResyncPricePoliciesUseCase } from "../../../Usecase/PricePolicies/resync-price-policies-usecase";


  interface IUseListPricePoliciesProps {

    listPricePoliciesUseCase: ListPricePoliciesUseCase
    destroyPricePoliciesUseCase: DestroyPricePoliciesUseCase
    resyncPricePoliciesUseCase: ResyncPricePoliciesUseCase
}
export function useListPricePolicies({  listPricePoliciesUseCase, destroyPricePoliciesUseCase, resyncPricePoliciesUseCase }: IUseListPricePoliciesProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<IPricePoliciesEntity[]>([])
    const [totalRegisters, setTotalRegisters] = useState(0)
    const [showFiltersModal, setShowFiltersModal] = useState(false)
    const [pricePolicyToDestroy, setPricePolicyToDestroy] = useState<IPricePoliciesEntity>()
    const [pricePolicyToResync, setPricePolicyToResync] = useState<IPricePoliciesEntity>()
    const renderControl = useRef(false)

    const { control } = useForm()

    const { showToast } =  useToast()

    const listPolicies = async ({ page: currentPage, searchBy}: { page : number; searchBy?: string }) => {
        
        try {
          setLoading(true)
          
          const listResult = await listPricePoliciesUseCase.handle({ page: currentPage, searchBy });

          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()
      
         if(list){
            setData(list.data)
            setTotalRegisters(list.total)
         }

         

         setPage(currentPage)
        } catch (error) {
          console.log("error listPolicies function: ", error)
        } finally {
          setLoading(false);
        }
      };
   

    const handleDestroyPricePolicy = async () => {
          
      try {
        setLoading(true)
        
        const listResult = await destroyPricePoliciesUseCase.handle(pricePolicyToDestroy?.id || '');

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

        showToast('Removido com sucesso.', 'success');
        listPolicies({ page: 1, searchBy: '' })

      

       setPricePolicyToDestroy(undefined)
      } catch (error) {
        console.log("error handleDestroy function: ", error)
      } finally {
        setLoading(false);
      }
    }

    const handleResyncPricePolicy = async () => {
          
      try {
        setLoading(true)
        
        const listResult = await resyncPricePoliciesUseCase.handle(pricePolicyToResync?.id || '');

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

        showToast('Re-sincronização iniciada com sucesso.', 'success');
        listPolicies({ page: 1, searchBy: '' })

      

       setPricePolicyToResync(undefined)
      } catch (error) {
        console.log("error handleResyncPricePolicy function: ", error)
      } finally {
        setLoading(false);
      }
    }

    useEffect(() => {
      if(renderControl.current) return
      renderControl.current = true
      listPolicies({ page: 1, searchBy: '' })
      
    }, [])

      

    return {
        loading,
        listPolicies,
        
        data,
        totalRegisters,
        control,
        showFiltersModal,
        setShowFiltersModal,
        pricePolicyToDestroy,
        setPricePolicyToDestroy,
        handleDestroyPricePolicy,
        pricePolicyToResync,
        setPricePolicyToResync,
        handleResyncPricePolicy
        
    }
}